export const config = {
  id: 'banner-dispenser',
  campainId: '/22775373496/7',
  target: 'chain',
  sizes: [1126, 250] as [number, number][] | [number, number],
};

export const EXECUTION_INTERVAL = 300; // milliseconds
export const MAX_TIMEOUT_COUNT = 40;
